var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddRulePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12546_152748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1797 56H14.8203C6.64836 56 0 49.3516 0 41.1797V14.8203C0 6.64836 6.64836 0 14.8203 0H41.1797C49.3516 0 56 6.64836 56 14.8203V41.1797C56 49.3516 49.3516 56 41.1797 56Z",
    fill: "#E9769E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1797 0H28V56H41.1797C49.3516 56 56 49.3516 56 41.1797V14.8203C56 6.64836 49.3516 0 41.1797 0Z",
    fill: "#E1497E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 30.5243V25.4757H25.4757V15H30.5243V25.4757H41V30.5243H30.5243V41H25.4757V30.5243H15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12546_152748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRulePlus);
export default __webpack_public_path__ + "static/media/add-rule-plus.f559e6a99b9eee5caaef86a628017e2e.svg";
export { ForwardRef as ReactComponent };